import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, throwError } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { catchError, tap } from "rxjs/operators";
import { AddNewQuestion } from "src/app/shared/addnewquestion";
import { Delivery, ItemUrls } from "../app.urls";
import { Examineelog, Toolslog } from "../shared/examineelog";

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  public updateEditText = new Subject<any>();
  public updateStemText = new Subject<any>();
  backButtonObs = new Subject<any>();
  reloadList = new Subject<any>();


  constructor(private http: HttpClient) { }

  getUpdateEditValue(value: any) {
    this.updateEditText.next(value);
  }

  addQuestion(question: any, itemuuId: any): Observable<any> {
    return this.http.post<any>(ItemUrls.AddQuestion + itemuuId + '/questions', question)
  };


  addExamineeLog(examineeLog: Examineelog): Observable<any> {
    return this.http.post<any>(Delivery.AddExamineeLog, examineeLog)
  };

  addToolsLog(toolsLog: Toolslog): Observable<any> {
    return this.http.post<any>(Delivery.AddToolsLog, toolsLog)
  };

  addFillBlankQuestion(question: any, itemuuId: any): Observable<any> {
    return this.http.post<any>(ItemUrls.AddFillBlankQuestion + itemuuId + '/questions', question)
  };


  getQuestion(itemId: any, queId: any): Observable<any> {
    return this.http.get<any>(ItemUrls.AddFillBlankQuestion + itemId + '/questions/' + queId)
  };

  updateQuestion(questionEdit: AddNewQuestion, itemId: any, queId: any): Observable<any> {
    return this.http.put<any>(ItemUrls.AddFillBlankQuestion + itemId + '/questions/' + queId, questionEdit)
  };

  updateHotspotQuestion(questionEdit: any, itemId: any, queId: any): Observable<any> {
    return this.http.put<any>(ItemUrls.AddFillBlankQuestion + itemId + '/questions/' + queId, questionEdit)
  };

  deleteQuestion(questionId: any, itemId: any): Observable<any> {
    return this.http.delete<any>(ItemUrls.AddFillBlankQuestion + `${itemId}/questions/${questionId}`)
  };

  deleteOption(questionId: any, Id: any): Observable<any> {
    return this.http.delete<any>(ItemUrls.AddFillBlankQuestion + questionId + '/options/' + Id)
  };

  deleteStem(questionId: any, Id: any): Observable<any> {
    return this.http.delete<any>(ItemUrls.AddFillBlankQuestion + questionId + '/stems/' + Id)
  };

  deletePrompt(questionId: any, promtid: number, matchorderid: number): Observable<any> {
    const DeletequestionapiUrl = ItemUrls.AddFillBlankQuestion + `${questionId}/matchOrder/${matchorderid}/prompts/${promtid}`;
    return this.http.delete<any>(DeletequestionapiUrl)
  }

  deleteResponse(questionId: any, responseid: number, matchorderid: number): Observable<any> {
    const DeletequestionapiUrl = ItemUrls.AddFillBlankQuestion + `${questionId}/matchOrder/${matchorderid}/responses/${responseid}`;
    return this.http.delete<any>(DeletequestionapiUrl)
  }

  getQuestionOrientation() {
    return this.http.get<any>(ItemUrls.QuestionOrientation)
  }

  getStatusList() {
    return this.http.get<any>(ItemUrls.statusList)
  }

  getQuestionScoringType() {
    return this.http.get<any>(ItemUrls.questionScoringType)
  }

  getAttendanceList() {
    return this.http.get<any>(ItemUrls.attendanceList)
  }

  getAnswerResultList() {
    return this.http.get<any>(ItemUrls.answerResultList)
  }

  uploadImageApi(file: File, uniqueId?) {
    let formParams = new FormData();
    formParams.append('uploadedFile', file);
    formParams.append('uniqueIdentifier', uniqueId)
    return this.http.post<any>(ItemUrls.uploadImg, formParams)
  }
}
